/** 任务来源 */
export enum TaskSource {
  /** 多语言裂变翻译 */
  Translate = 'translate',
  /** 人声分离 */
  VocalSeparation = 'vocal_separation',
  /** 更新配音 */
  UpdateSpeech = 'update_speech',
  /** 视频ocr */
  VideoOcr = 'video_ocr',
}

export enum TaskStatus {
  Pending = 'pending',
  /** 查询中 */
  Querying = 'querying',
  /** 异步任务完成，处理任务的数据，比如拿到数据生成元件之类的 */
  Running = 'running',
  Success = 'success',
}
